import React from 'react'
import Logo from '../assets/navlogo.png'
const Navber = () => {
  return (
    <section id='navber' className='w-full h-[105px] bg-[#F40404]'>
    <div className="max-w-container mx-auto">
        <div className="flex py-[30px]">
     <div className="w-1/3">
       <img src={Logo} alt="" />
     </div>
     <div className="w-4/6 flex items-center justify-center">
       <ul className='flex'>
        <li className='px-[23.5px]'><a href="" className='font-poppi text-white hover:text-black' >Home</a></li>
        <li className='px-[23.5px]'><a href="" className='font-poppi text-white hover:text-black' >About</a></li>
        <li className='px-[23.5px]'><a href="" className='font-poppi text-white hover:text-black'>Service</a></li>
        <li className='px-[23.5px]'><a href="" className='font-poppi text-white hover:text-black'>Gallery</a></li>
        <li className='px-[23.5px]'><a href="" className='font-poppi text-white hover:text-black'>Blog</a></li>
        <li className='px-[23.5px]'><a href="" className='font-poppi text-white hover:text-black border-2 py-[12.5px] px-[31px] hover:bg-white'>Contact</a></li>
       </ul>
     </div>
        </div>
    </div>
    </section>
  )
}

export default Navber